import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as CommonConstants from '../../utils/common.constants';
import {MasterService} from'../../masters/master.service';
import { AddCountryComponent } from './add-country/add-country.component';
import { LoaderService } from 'src/app/common/loader.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { AreaLevelsComponent } from '../area-levels/area-levels.component';
import { FileExportService } from 'src/app/utils/file-export-service';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.scss']
})
export class CountryComponent implements OnInit {
  columnDefs:any[];
  rowData: any[];
  countryList:any[];
  area1List:any[];
  area2List:any[];
  area3List:any[];
  area4List:any[];
  countryFullList:any[];
  area1FullList:any[];
  area2FullList:any[];
  area3FullList:any[];
  area4FullList:any[];
  toggleColumn = true;
  addnewCountry;
  masterSearchForm: FormGroup;
  newCountry: AreaLevelsComponent;
  searchCriteria={};
  shName=''
  @ViewChild(AreaLevelsComponent, { static: true }) set Content(newCountryRef) {
    this.newCountry = newCountryRef;
  }

  constructor(private formBuilder: FormBuilder,private router:Router,private route: ActivatedRoute,private masterService:MasterService,private loaderService: LoaderService,config: NgbModalConfig, private modalService: NgbModal,private exportService:FileExportService) {
    this.route.queryParams.subscribe(param =>{
      this.shName=param.masterShName;
      this.loadMasterData();
    });
    this.getMasterForm();
    this.masterSearch(this.shName);
   }
loadMasterData(){
  //Country
  this.searchCriteria={
    masterShName:'COUNTRY',
    master:{}
  }
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
    this.countryList= response['result'];
  })
  this.loadArea1(null);
  this.loadArea2(null);
  this.loadArea3(null);
  this.loadArea4(null);
}
loadArea1(id){
   //AREALEVEL1
   if(id!=null){
    this.searchCriteria={
      masterShName:'AREALEVEL1',
      master:{cotryId:id}
    }
    this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
      this.area1List= response['result'];
    })
   }else {
    this.searchCriteria={
      masterShName:'AREALEVEL1',
      master:{}
    }
    this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
      this.area1FullList= response['result'];
    })
   }
}

loadArea2(id){
  //AREALEVEL1
  if(id!=null){
  this.searchCriteria={
   masterShName:'AREALEVEL2',
   master:{area1Id:id}
 }
 this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
   this.area2List= response['result'];
 })
}else {
  this.searchCriteria={
    masterShName:'AREALEVEL2',
    master:{}
  }
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
    this.area2FullList= response['result'];
  })
}
}

loadArea3(id){
  //AREALEVEL1
  if(id!=null){
  this.searchCriteria={
   masterShName:'AREALEVEL3',
   master:{area2Id:id}
 }
 this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
   this.area3List= response['result'];
 })
}else {
  this.searchCriteria={
    masterShName:'AREALEVEL3',
    master:{}
  }
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
    this.area3FullList= response['result'];
  })
}
}

loadArea4(id){
  //AREALEVEL4
  if(id!=null){
    this.searchCriteria={
      masterShName:'AREALEVEL4',
      master:{area3Id:id}
    }
    this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
      this.area4List= response['result'];
    })
  }else{
    this.searchCriteria={
      masterShName:'AREALEVEL4',
      master:{}
    }
    this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
      this.area4FullList= response['result'];
    })
  }
  
}
masterSearch(masterShName){
  this.searchCriteria={};
  this.BuildSearchCriteria(masterShName);
  this.loaderService.display(true);
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
   let result = response['result'];
   this.loaderService.display(false);
  this.prepareGridRowData(this.shName,result);
 })
}
  ngOnInit() {
  }
  onRowClicked(event){
  this.newCountry.shName=this.shName;
  //this.newCountry.addCountryTitle = false;
  //this.newCountry.editCountryTitle = true;
  this.toggleColumn = false;
  this.addnewCountry=true;
  this.loadMasterById(event);

  }
  addNewCountry(){
    this.router.navigate(['areaLevels'],{queryParams: {masterShName: this.shName}});
    this.newCountry.shName=this.shName;
    //this.newCountry.addCountryTitle = true;
    //this.newCountry.editCountryTitle = false;
  }
  hideRightDiv(){
    this.addnewCountry=false;
    this.toggleColumn = true;
  }
  exportExcel() {
  this.exportService.exportAsExcelFile(this.rowData,this.shName);
}
exportPdf() {
let exportColumns = this.rowData.map(col => ({title: col.header, dataKey: col.field}));
this.exportService.exportPdf(exportColumns,this.rowData,this.shName);
}
loadMasterById(event){
  this.loaderService.display(true);
  this.fetchByIdIp(event)
  this.masterService.searchMaster(this.searchCriteria).subscribe(response => {
    this.loaderService.display(false);
    if (response['code'] == 'S0000') {
      let result = response['result'][0];
      this.newCountry.patchFormValues(result,this.shName);
    }
  });
}
 onCountryRowSelect(country, editCountry) {
  this.modalService.open(editCountry, { size: 'lg', container: '.page-content' });
  this.newCountry.geographyForm =  JSON.parse(JSON.stringify(country.data));
}  
get f() {
  return this.masterSearchForm.controls;
}
private getMasterForm() {
  this.masterSearchForm = this.formBuilder.group({
    'code': new FormControl(),
    'description': new FormControl(),
    'cotryId': new FormControl(),
    'area1Id': new FormControl(),
    'area2Id': new FormControl(),
    'area3Id': new FormControl(),
    'area4Id': new FormControl()
  })
}
BuildSearchCriteria(shName){
      let masterIp={
        code:this.f.code.value,
        description:this.f.description.value
      }
      if(shName=='AREALEVEL1'){
        masterIp['cotryId']=this.f.cotryId.value
      }
      else if(shName=='AREALEVEL2'){
        masterIp['area1Id']=this.f.cotryId.value
      }
      else if(shName=='AREALEVEL3'){
        masterIp['area2Id']=this.f.cotryId.value
      }
      else if(shName=='AREALEVEL4'){
        masterIp['area3Id']=this.f.cotryId.value
      }
      this.searchCriteria={
        masterShName:shName,
        master:masterIp
  }
}
fetchByIdIp(event){
    let searchIp={
      id:event.data.id
    }
    this.searchCriteria={
      masterShName:this.shName,
      master:searchIp
    }
}
prepareGridRowData(shName,result){
  this.rowData=[];
      for(let r of result){
        let gRow={
          id:r.id,
          code:r.code,
          descriptionEn:r.description,
          descriptionFr:r.descriptionFr,
          codeInternational:r.codeInternational,
          codeLocal:r.codeLocal,
          contiCode:r.contiCode,
          ctareCode:r.ctareCode
        }
        if(shName!='COUNTRY'){
          r.cotryId ? gRow['cotryId']=this.countryList.filter(country => r.cotryId && country.id == r.cotryId)[0].description:'';
        }
        if(shName=='AREALEVEL2' || shName=='AREALEVEL3' || shName=='AREALEVEL4' || shName=='TOWN'){
          r.area1Id ? gRow['area1Id']=this.area1FullList.filter(area1 => r.area1Id && area1.id == r.area1Id)[0].description :'';
        }
        if(shName=='AREALEVEL3' || shName=='AREALEVEL4' || shName=='TOWN'){
          r.area2Id ? gRow['area2Id']=this.area2FullList.filter(area2 => r.area2Id && area2.id == r.area2Id)[0].description: '';
        }
        if(shName=='AREALEVEL4' || shName=='TOWN'){
          r.area3Id ? gRow['area3Id']=this.area3FullList.filter(area3 => r.area3Id && area3.id == r.area3Id)[0].description :'';
        }
        if(shName=='TOWN'){
          r.area4Id ? gRow['area4Id']=this.area4FullList.filter(area4 => r.area4Id && area4.id == r.area4Id)[0].description :'';
        }
        this.rowData.push(gRow);
      }
}
resetForm(){
  this.masterSearchForm.reset();
  this.rowData=[];
}
}
